module.exports = __webpack_public_path__ + "img/jpg1_icon_zhujie.ca6f771b.png";